import { useEffect, useRef, useState } from "react";
import { useIdeasNodeStore } from "../../stores/ideaNodesStore";
import TextareaAutosize from "react-textarea-autosize";
import {
  textAreaInnerContainer,
  textAreaInnerContainerOnActionPopover,
  textareaInputBar,
  textareaInputBarOnActionPopover,
  textareaSendButton,
} from "../summary_session_styles";
import { Popover } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";

interface actionProps {
  targetText: string;
  parentNodeIdPath: string;
}

export const AIActionsButtons = (props: actionProps) => {
  const startRequest = useIdeasNodeStore((state) => state.startRequest);
  const expandToggleNode = useIdeasNodeStore((state) => state.expandToggleNode);

  const handleDigDeeperOnSource = (e: any) => {
    // TODO: Handle 2nd and above clicks (currently only the first one works properly)
    startRequest({
      action: "dig_deeper_on_source",
      target_text: props.targetText,
      parent_node_id_path: props.parentNodeIdPath,
    });

    expandToggleNode(props.parentNodeIdPath);
  };

  const handleQandA = (e: any) => {
    alert("clicked on magnifying glass");
  };
  return (
    <>
      <span onClick={handleDigDeeperOnSource}>➕</span>{" "}
      <span>
        <SearchAction {...props} />
      </span>
      <span onClick={handleQandA}>🌐</span>
    </>
  );
};

export const SearchActionPopover = (props: actionProps & { setOpen: any }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const submitChatPaneNewUserUtterance = useIdeasNodeStore(
    (state) => state.submitChatPaneNewUserUtteranceEphemeral
  );

  const [searchActionPopoverText, setSearchActionPopoverText] = useState("");

  useEffect(() => {
    setTimeout(() => {
      if (textareaRef && textareaRef.current) {
        textareaRef.current.focus();
        // console.log(textareaRef.current); // Debugging reference is set correctly
      }
    }, 75); // without this timeout, the focus action would only work the first time you open the popover, but not on subsequent times
  });

  return (
    <div
      css={[textAreaInnerContainer, textAreaInnerContainerOnActionPopover]}
      // onClick={() => {
      //   // textAreaRef.current?.focus();
      // }}
    >
      <TextareaAutosize
        ref={textareaRef}
        minRows={1}
        maxRows={4}
        placeholder="Ask..."
        autoFocus={true}
        css={[textareaInputBar, textareaInputBarOnActionPopover]}
        value={searchActionPopoverText}
        onChange={(e) => setSearchActionPopoverText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            submitChatPaneNewUserUtterance(
              searchActionPopoverText,
              props.targetText
            );

            props.setOpen(false);
          }
        }}
      />

      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          submitChatPaneNewUserUtterance(
            searchActionPopoverText,
            props.targetText
          );

          props.setOpen(false);
        }}
        css={textareaSendButton}
      >
        <ArrowRightOutlined />
      </button>
    </div>
  );
};

const SearchAction = (props: actionProps) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  return (
    <>
      <Popover
        content={<SearchActionPopover setOpen={setOpen} {...props} />}
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
      >
        🔎
      </Popover>
    </>
  );
};
